<template>
  <div class="top-bar-notifications">
    <transition name="notification">
      <div class="notification clearfix" v-if="notification">
        <div class="notification-type clearfix notification-error" v-if="notification.type === TOP_BAR_NOTIFICATION_TYPES.ERROR">
          <div class="notification-icon">
            <i class="ion-alert"></i>
          </div>
          <div class="notification-text">
            {{ notification.text }}
          </div>
          <div class="notification-close">
            <a href="#" @click.prevent="removeTopBarNotification()">
              <i class="ion-ios-close-empty"></i>
            </a>
          </div>
        </div>
        <div class="notification-type clearfix notification-info" v-if="notification.type === TOP_BAR_NOTIFICATION_TYPES.INFO">
          <div class="notification-icon">
            <i class="ion-ios-information-outline"></i>
          </div>
          <div class="notification-text">
            {{ notification.text }}
          </div>
          <div class="notification-close">
            <a href="#" @click.prevent="removeTopBarNotification()">
              <i class="ion-ios-close-empty"></i>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TOP_BAR_NOTIFICATION_TYPES from 'constants/topBarNotificationTypes'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'

export default {
  name: 'top-bar-notifications',
  data() {
    return {
      TOP_BAR_NOTIFICATION_TYPES,
    }
  },
  computed: {
    notification() {
      const noti = this.$store.state.topBarNotifications.notification

      if (!noti) return null

      noti.type = noti.type || TOP_BAR_NOTIFICATION_TYPES.ERROR

      return noti
    },
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.ADD_TOP_BAR_NOTIFICATION) {
        if (this.removeNotificationsTimeout) {
          window.clearTimeout(this.removeNotificationsTimeout)
        }

        if (this.notification.timeout) {
          this.removeNotificationsTimeout = setTimeout(() => {
            this.removeTopBarNotification()
          }, this.notification.timeout)
        }
      }
    },
    removeTopBarNotification() {
      this.$store.dispatch('removeTopBarNotification')
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)
  },
  destroyed() {
    this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TopBarNotifications.vue